import React, { ReactNode } from 'react';
import './style.scss';

interface PropsType {
    type?: string;
    disabled?: boolean;
    onClick: () => void;
    children: ReactNode;
}

const NavButton = ({ type, disabled, onClick, children }: PropsType) => {
    type = type ? type : 'btn-primary';
    return (
        <a className={`btn anchor-btn ${type} ${disabled ? 'disabled' : ''}`} onClick={() => !disabled && onClick()}>
            {children}
        </a>
    );
};

export default NavButton;
